import { useState, useEffect, useRef } from "react";
import { CustomDropdown } from "./CustomDropdown";

// Eliminadas las interfaces Option y RangeSelectsProps

export default function RangeSelects({ onChange, disabled = false }) {
    /* =======================
       Opciones
    ======================== */
    const months = [
        { label: "Ene", value: 0 },
        { label: "Feb", value: 1 },
        { label: "Mar", value: 2 },
        { label: "Abr", value: 3 },
        { label: "May", value: 4 },
        { label: "Jun", value: 5 },
        { label: "Jul", value: 6 },
        { label: "Ago", value: 7 },
        { label: "Sep", value: 8 },
        { label: "Oct", value: 9 },
        { label: "Nov", value: 10 },
        { label: "Dic", value: 11 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i;
        return { label: String(year), value: year };
    });

    /* =======================
       Estado (Limpio de genéricos <...>)
    ======================== */
    const [from, setFrom] = useState({
        month: null,
        year: null,
    });

    const [to, setTo] = useState({
        month: null,
        year: null,
    });

    /* =======================
       Helpers
    ======================== */
    const format = (m, y) =>
        m && y ? `${y.value}-${String(Number(m.value) + 1).padStart(2, "0")}` : null;

    const toNumber = (m, y) =>
        m && y ? Number(`${y.value}${String(Number(m.value) + 1).padStart(2, "0")}`) : null;

    const fromValue = toNumber(from.month, from.year);
    const toValue = toNumber(to.month, to.year);

    const isFromComplete = !!fromValue;
    const isToInvalid = toValue !== null && fromValue !== null && toValue < fromValue;

    // Eliminado el tipo NodeJS.Timeout
    const debounceRef = useRef(null);

    /* =======================
       Effects
    ======================== */
    useEffect(() => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            onChange({
                from: format(from.month, from.year),
                to: toValue ? format(to.month, to.year) : null,
            });
        }, 400); 
    }, [fromValue, toValue]);

    /* =======================
       Render
    ======================== */
    return (
        <div className="flex flex-col gap-2 w-full">
            <p className="text-xs text-gray-500 mb-1">
                <span className="font-bold">Nota:</span> Seleccione solo <span className="font-semibold">"Desde"</span> para ver un mes específico. Seleccione también <span className="font-semibold">"Hasta"</span> para ver un rango de fechas.
            </p>
            <div className="flex gap-3 w-full items-start">
                {/* DESDE */}
                <div className="w-1/4">
                    <strong className="block mb-1">Desde</strong>
                    <div className="flex gap-1 relative">
                        <div className="w-1/2">
                            <CustomDropdown
                                options={months}
                                selected={from.month}
                                placeholder="Mes"
                                onChange={(opt) => setFrom({ ...from, month: opt })}
                                disabled={disabled}
                            />
                        </div>

                        <div className="w-1/2">
                            <CustomDropdown
                                options={years}
                                selected={from.year}
                                placeholder="Año"
                                onChange={(opt) => setFrom({ ...from, year: opt })}
                                disabled={disabled}
                            />
                        </div>
                        {(from.month || from.year) && !disabled && (
                            <div
                                onClick={() => setFrom({ month: null, year: null })}
                                className="bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center absolute -top-5 right-0"
                                title="Limpiar fecha desde"
                            >
                                x
                            </div>
                        )}
                    </div>
                </div>

                {/* HASTA */}
                <div className="w-1/4">
                    <strong className="block mb-1">Hasta</strong>
                    <div className="flex gap-1 relative">
                        <div className="w-1/2">
                            <CustomDropdown
                                options={months}
                                selected={to.month}
                                placeholder="Mes"
                                disabled={disabled || !isFromComplete}
                                onChange={(opt) => setTo({ ...to, month: opt })}
                            />
                        </div>

                        <div className="w-1/2">
                            <CustomDropdown
                                options={years}
                                selected={to.year}
                                placeholder="Año"
                                disabled={disabled || !isFromComplete}
                                onChange={(opt) => setTo({ ...to, year: opt })}
                            />
                        </div>
                        {(to.month || to.year) && !disabled && (
                            <div
                                onClick={() => setTo({ month: null, year: null })}
                                className="bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center absolute -top-5 right-0"
                                title="Limpiar fecha hasta"
                            >
                                x
                            </div>
                        )}
                    </div>

                    {isToInvalid && (
                        <p className="text-red-600 text-sm mt-1">
                            La fecha "Hasta" no puede ser menor que "Desde"
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}